import { render, staticRenderFns } from "./orderItemTemplateCreateModal.vue?vue&type=template&id=0af831d9&"
import script from "./orderItemTemplateCreateModal.vue?vue&type=script&lang=ts&"
export * from "./orderItemTemplateCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports